import CustomError from './customError';

export default class NotFoundError extends CustomError {}
